import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { INCIDENT_API } from "./apiRoutes";

interface UseGetIncidentListProps {
  data: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentList = async (data: any, communityId: string) =>
  await axiosAuth.post(`${INCIDENT_API(communityId)}/grid`, data);

const useGetIncidentList = ({
  data,
  communityId,
  queryParams,
}: UseGetIncidentListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-list"],
    queryFn: () => getIncidentList(data, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetIncidentList;
